(function () {
    'use strict';

    angular.module("imApp").factory("jobSchedulesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1661,
                    parameters: parms || {}
                });
            },
            listJobSchedules: function (parms) {
                return $ihttp.post({
                    method: 1662,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
